import AC from '../../../assets/flags/AC.svg';
import AD from '../../../assets/flags/AD.svg';
import AE from '../../../assets/flags/AE.svg';
import AF from '../../../assets/flags/AF.svg';
import AG from '../../../assets/flags/AG.svg';
import AI from '../../../assets/flags/AI.svg';
import AL from '../../../assets/flags/AL.svg';
import AM from '../../../assets/flags/AM.svg';
import AO from '../../../assets/flags/AO.svg';
import AQ from '../../../assets/flags/AQ.svg';
import AR from '../../../assets/flags/AR.svg';
import AS from '../../../assets/flags/AS.svg';
import AT from '../../../assets/flags/AT.svg';
import AU from '../../../assets/flags/AU.svg';
import AW from '../../../assets/flags/AW.svg';
import AX from '../../../assets/flags/AX.svg';
import AZ from '../../../assets/flags/AZ.svg';
import BA from '../../../assets/flags/BA.svg';
import BB from '../../../assets/flags/BB.svg';
import BD from '../../../assets/flags/BD.svg';
import BE from '../../../assets/flags/BE.svg';
import BF from '../../../assets/flags/BF.svg';
import BG from '../../../assets/flags/BG.svg';
import BH from '../../../assets/flags/BH.svg';
import BI from '../../../assets/flags/BI.svg';
import BJ from '../../../assets/flags/BJ.svg';
import BL from '../../../assets/flags/BL.svg';
import BM from '../../../assets/flags/BM.svg';
import BN from '../../../assets/flags/BN.svg';
import BO from '../../../assets/flags/BO.svg';
import BQ from '../../../assets/flags/BQ.svg';
import BR from '../../../assets/flags/BR.svg';
import BS from '../../../assets/flags/BS.svg';
import BT from '../../../assets/flags/BT.svg';
import BV from '../../../assets/flags/BV.svg';
import BW from '../../../assets/flags/BW.svg';
import BY from '../../../assets/flags/BY.svg';
import BZ from '../../../assets/flags/BZ.svg';
import CA from '../../../assets/flags/CA.svg';
import CC from '../../../assets/flags/CC.svg';
import CD from '../../../assets/flags/CD.svg';
import CF from '../../../assets/flags/CF.svg';
import CG from '../../../assets/flags/CG.svg';
import CH from '../../../assets/flags/CH.svg';
import CI from '../../../assets/flags/CI.svg';
import CK from '../../../assets/flags/CK.svg';
import CL from '../../../assets/flags/CL.svg';
import CM from '../../../assets/flags/CM.svg';
import CN from '../../../assets/flags/CN.svg';
import CO from '../../../assets/flags/CO.svg';
import CR from '../../../assets/flags/CR.svg';
import CU from '../../../assets/flags/CU.svg';
import CV from '../../../assets/flags/CV.svg';
import CW from '../../../assets/flags/CW.svg';
import CX from '../../../assets/flags/CX.svg';
import CY from '../../../assets/flags/CY.svg';
import CZ from '../../../assets/flags/CZ.svg';
import DE from '../../../assets/flags/DE.svg';
import DJ from '../../../assets/flags/DJ.svg';
import DK from '../../../assets/flags/DK.svg';
import DM from '../../../assets/flags/DM.svg';
import DO from '../../../assets/flags/DO.svg';
import DZ from '../../../assets/flags/DZ.svg';
import EC from '../../../assets/flags/EC.svg';
import EE from '../../../assets/flags/EE.svg';
import EG from '../../../assets/flags/EG.svg';
import EH from '../../../assets/flags/EH.svg';
import ER from '../../../assets/flags/ER.svg';
import ES from '../../../assets/flags/ES.svg';
import ET from '../../../assets/flags/ET.svg';
import EU from '../../../assets/flags/EU.svg';
import FI from '../../../assets/flags/FI.svg';
import FJ from '../../../assets/flags/FJ.svg';
import FK from '../../../assets/flags/FK.svg';
import FM from '../../../assets/flags/FM.svg';
import FO from '../../../assets/flags/FO.svg';
import FR from '../../../assets/flags/FR.svg';
import GA from '../../../assets/flags/GA.svg';
import GB from '../../../assets/flags/GB.svg';
import GD from '../../../assets/flags/GD.svg';
import GE from '../../../assets/flags/GE.svg';
import GF from '../../../assets/flags/GF.svg';
import GG from '../../../assets/flags/GG.svg';
import GH from '../../../assets/flags/GH.svg';
import GN from '../../../assets/flags/GN.svg';
import GP from '../../../assets/flags/GP.svg';
import GQ from '../../../assets/flags/GQ.svg';
import GR from '../../../assets/flags/GR.svg';
import GS from '../../../assets/flags/GS.svg';
import GT from '../../../assets/flags/GT.svg';
import GU from '../../../assets/flags/GU.svg';
import GW from '../../../assets/flags/GW.svg';
import GY from '../../../assets/flags/GY.svg';
import HK from '../../../assets/flags/HK.svg';
import HM from '../../../assets/flags/HM.svg';
import HN from '../../../assets/flags/HN.svg';
import HR from '../../../assets/flags/HR.svg';
import HT from '../../../assets/flags/HT.svg';
import HU from '../../../assets/flags/HU.svg';
import ID from '../../../assets/flags/ID.svg';
import IE from '../../../assets/flags/IE.svg';
import IL from '../../../assets/flags/IL.svg';
import IM from '../../../assets/flags/IM.svg';
import IN from '../../../assets/flags/IN.svg';
import IO from '../../../assets/flags/IO.svg';
import IQ from '../../../assets/flags/IQ.svg';
import IR from '../../../assets/flags/IR.svg';
import IS from '../../../assets/flags/IS.svg';
import IT from '../../../assets/flags/IT.svg';
import JE from '../../../assets/flags/JE.svg';
import JM from '../../../assets/flags/JM.svg';
import JO from '../../../assets/flags/JO.svg';
import JP from '../../../assets/flags/JP.svg';
import KE from '../../../assets/flags/KE.svg';
import KG from '../../../assets/flags/KG.svg';
import KH from '../../../assets/flags/KH.svg';
import KI from '../../../assets/flags/KI.svg';
import KM from '../../../assets/flags/KM.svg';
import KN from '../../../assets/flags/KN.svg';
import KP from '../../../assets/flags/KP.svg';
import KR from '../../../assets/flags/KR.svg';
import KW from '../../../assets/flags/KW.svg';
import KY from '../../../assets/flags/KY.svg';
import KZ from '../../../assets/flags/KZ.svg';
import LA from '../../../assets/flags/LA.svg';
import LB from '../../../assets/flags/LB.svg';
import LC from '../../../assets/flags/LC.svg';
import LI from '../../../assets/flags/LI.svg';
import LK from '../../../assets/flags/LK.svg';
import LR from '../../../assets/flags/LR.svg';
import LS from '../../../assets/flags/LS.svg';
import LT from '../../../assets/flags/LT.svg';
import LU from '../../../assets/flags/LU.svg';
import LV from '../../../assets/flags/LV.svg';
import LY from '../../../assets/flags/LY.svg';
import MA from '../../../assets/flags/MA.svg';
import MC from '../../../assets/flags/MC.svg';
import MD from '../../../assets/flags/MD.svg';
import ME from '../../../assets/flags/ME.svg';
import MF from '../../../assets/flags/MF.svg';
import MG from '../../../assets/flags/MG.svg';
import MH from '../../../assets/flags/MH.svg';
import MK from '../../../assets/flags/MK.svg';
import ML from '../../../assets/flags/ML.svg';
import MM from '../../../assets/flags/MM.svg';
import MN from '../../../assets/flags/MN.svg';
import MO from '../../../assets/flags/MO.svg';
import MP from '../../../assets/flags/MP.svg';
import MQ from '../../../assets/flags/MQ.svg';
import MR from '../../../assets/flags/MR.svg';
import MS from '../../../assets/flags/MS.svg';
import MT from '../../../assets/flags/MT.svg';
import MU from '../../../assets/flags/MU.svg';
import MV from '../../../assets/flags/MV.svg';
import MW from '../../../assets/flags/MW.svg';
import MX from '../../../assets/flags/MX.svg';
import MY from '../../../assets/flags/MY.svg';
import MZ from '../../../assets/flags/MZ.svg';
import NA from '../../../assets/flags/NA.svg';
import NC from '../../../assets/flags/NC.svg';
import NE from '../../../assets/flags/NE.svg';
import NF from '../../../assets/flags/NF.svg';
import NG from '../../../assets/flags/NG.svg';
import NI from '../../../assets/flags/NI.svg';
import NL from '../../../assets/flags/NL.svg';
import NO from '../../../assets/flags/NO.svg';
import NP from '../../../assets/flags/NP.svg';
import NR from '../../../assets/flags/NR.svg';
import NU from '../../../assets/flags/NU.svg';
import NZ from '../../../assets/flags/NZ.svg';
import OM from '../../../assets/flags/OM.svg';
import PA from '../../../assets/flags/PA.svg';
import PE from '../../../assets/flags/PE.svg';
import PF from '../../../assets/flags/PF.svg';
import PG from '../../../assets/flags/PG.svg';
import PH from '../../../assets/flags/PH.svg';
import PK from '../../../assets/flags/PK.svg';
import PL from '../../../assets/flags/PL.svg';
import PM from '../../../assets/flags/PM.svg';
import PN from '../../../assets/flags/PN.svg';
import PR from '../../../assets/flags/PR.svg';
import PS from '../../../assets/flags/PS.svg';
import PT from '../../../assets/flags/PT.svg';
import PW from '../../../assets/flags/PW.svg';
import PY from '../../../assets/flags/PY.svg';
import QA from '../../../assets/flags/QA.svg';
import RE from '../../../assets/flags/RE.svg';
import RO from '../../../assets/flags/RO.svg';
import RS from '../../../assets/flags/RS.svg';
import RU from '../../../assets/flags/RU.svg';
import RW from '../../../assets/flags/RW.svg';
import SA from '../../../assets/flags/SA.svg';
import SB from '../../../assets/flags/SB.svg';
import SC from '../../../assets/flags/SC.svg';
import SD from '../../../assets/flags/SD.svg';
import SE from '../../../assets/flags/SE.svg';
import SG from '../../../assets/flags/SG.svg';
import SH from '../../../assets/flags/SH.svg';
import SI from '../../../assets/flags/SI.svg';
import SJ from '../../../assets/flags/SJ.svg';
import SK from '../../../assets/flags/SK.svg';
import SL from '../../../assets/flags/SL.svg';
import SM from '../../../assets/flags/SM.svg';
import SN from '../../../assets/flags/SN.svg';
import SO from '../../../assets/flags/SO.svg';
import SR from '../../../assets/flags/SR.svg';
import SS from '../../../assets/flags/SS.svg';
import ST from '../../../assets/flags/ST.svg';
import SV from '../../../assets/flags/SV.svg';
import SX from '../../../assets/flags/SX.svg';
import SY from '../../../assets/flags/SY.svg';
import SZ from '../../../assets/flags/SZ.svg';
import TA from '../../../assets/flags/TA.svg';
import TC from '../../../assets/flags/TC.svg';
import TD from '../../../assets/flags/TD.svg';
import TF from '../../../assets/flags/TF.svg';
import TG from '../../../assets/flags/TG.svg';
import TH from '../../../assets/flags/TH.svg';
import TJ from '../../../assets/flags/TJ.svg';
import TK from '../../../assets/flags/TK.svg';
import TL from '../../../assets/flags/TL.svg';
import TM from '../../../assets/flags/TM.svg';
import TN from '../../../assets/flags/TN.svg';
import TO from '../../../assets/flags/TO.svg';
import TR from '../../../assets/flags/TR.svg';
import TT from '../../../assets/flags/TT.svg';
import TW from '../../../assets/flags/TW.svg';
import TZ from '../../../assets/flags/TZ.svg';
import UA from '../../../assets/flags/UA.svg';
import UG from '../../../assets/flags/UG.svg';
import UM from '../../../assets/flags/UM.svg';
import US from '../../../assets/flags/US.svg';
import UY from '../../../assets/flags/UY.svg';
import UZ from '../../../assets/flags/UZ.svg';
import VA from '../../../assets/flags/VA.svg';
import VC from '../../../assets/flags/VA.svg';
import VE from '../../../assets/flags/VE.svg';
import VG from '../../../assets/flags/VG.svg';
import VI from '../../../assets/flags/VI.svg';
import VN from '../../../assets/flags/VN.svg';
import VU from '../../../assets/flags/VU.svg';
import WF from '../../../assets/flags/WF.svg';
import WS from '../../../assets/flags/WS.svg';
import XK from '../../../assets/flags/XK.svg';
import YE from '../../../assets/flags/YE.svg';
import YT from '../../../assets/flags/YT.svg';
import ZA from '../../../assets/flags/ZA.svg';
import ZM from '../../../assets/flags/ZM.svg';
import ZW from '../../../assets/flags/ZW.svg';

export interface CountryType {
    code: string;
    name: string;
    phone: string;
    dkName: string;
    suggested?: boolean;
    imageUrl: string;
}
// export interface CollectionDate {
//     collDate: string;
//     recievDate: string;
// }

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const newCountries: readonly CountryType[] = [
    { code: 'AD', name: 'Andorra', phone: '376', dkName: '', imageUrl: AD },
    {
        code: 'AE',
        name: 'United Arab Emirates',
        phone: '971',
        dkName: 'UAE',
        imageUrl: AE
    },
    { code: 'AF', name: 'Afghanistan', phone: '93', dkName: '', imageUrl: AF },
    {
        code: 'AG',
        name: 'Antigua and Barbuda',
        phone: '1-268',
        dkName: '',
        imageUrl: AG
    },
    { code: 'AI', name: 'Anguilla', phone: '1-264', dkName: '', imageUrl: AI },
    { code: 'AL', name: 'Albania', phone: '355', dkName: '', imageUrl: AL },
    { code: 'AM', name: 'Armenia', phone: '374', dkName: '', imageUrl: AM },
    { code: 'AO', name: 'Angola', phone: '244', dkName: '', imageUrl: AO },
    { code: 'AQ', name: 'Antarctica', phone: '672', dkName: '', imageUrl: AQ },
    { code: 'AR', name: 'Argentina', phone: '54', dkName: 'ARGENTINA', imageUrl: AR },
    { code: 'AS', name: 'American Samoa', phone: '1-684', dkName: '', imageUrl: AS },
    { code: 'AT', name: 'Austria', phone: '43', dkName: 'ØSTRIG', imageUrl: AT },
    {
        code: 'AU',
        name: 'Australia',
        phone: '61',
        suggested: true,
        dkName: 'AUSTRALIEN', imageUrl: AU
    },
    { code: 'AW', name: 'Aruba', phone: '297', dkName: '', imageUrl: AW },
    { code: 'AX', name: 'Alland Islands', phone: '358', dkName: '', imageUrl: AX },
    { code: 'AZ', name: 'Azerbaijan', phone: '994', dkName: '', imageUrl: AZ },
    {
        code: 'BA',
        name: 'Bosnia and Herzegovina',
        phone: '387',
        dkName: '', imageUrl: BA
    },
    { code: 'BB', name: 'Barbados', phone: '1-246', dkName: '', imageUrl: BB },
    { code: 'BD', name: 'Bangladesh', phone: '880', dkName: '', imageUrl: BD },
    { code: 'BE', name: 'Belgium', phone: '32', dkName: 'BELGIEN', imageUrl: BE },
    { code: 'BF', name: 'Burkina Faso', phone: '226', dkName: '', imageUrl: BF },
    { code: 'BG', name: 'Bulgaria', phone: '359', dkName: 'BULGARIEN', imageUrl: BG },
    { code: 'BH', name: 'Bahrain', phone: '973', dkName: '', imageUrl: BH },
    { code: 'BI', name: 'Burundi', phone: '257', dkName: '', imageUrl: BI },
    { code: 'BJ', name: 'Benin', phone: '229', dkName: '', imageUrl: BJ },
    { code: 'BL', name: 'Saint Barthelemy', phone: '590', dkName: '', imageUrl: BL },
    { code: 'BM', name: 'Bermuda', phone: '1-441', dkName: '', imageUrl: BM },
    { code: 'BN', name: 'Brunei Darussalam', phone: '673', dkName: '', imageUrl: BN },
    { code: 'BO', name: 'Bolivia', phone: '591', dkName: '', imageUrl: BO },
    { code: 'BR', name: 'Brazil', phone: '55', dkName: 'BRASILIEN', imageUrl: BR },
    { code: 'BS', name: 'Bahamas', phone: '1-242', dkName: '', imageUrl: BS },
    { code: 'BT', name: 'Bhutan', phone: '975', dkName: '', imageUrl: BT },
    { code: 'BV', name: 'Bouvet Island', phone: '47', dkName: '', imageUrl: BV },
    { code: 'BW', name: 'Botswana', phone: '267', dkName: '', imageUrl: BW },
    { code: 'BY', name: 'Belarus', phone: '375', dkName: '', imageUrl: BY },
    { code: 'BZ', name: 'Belize', phone: '501', dkName: '', imageUrl: BZ },
    {
        code: 'CA',
        name: 'Canada',
        phone: '1',
        suggested: true,
        dkName: 'CANADA', imageUrl: CA
    },
    {
        code: 'CC',
        name: 'Cocos (Keeling) Islands',
        phone: '61',
        dkName: '', imageUrl: CC
    },
    {
        code: 'CD',
        name: 'Congo, Democratic Republic of the',
        phone: '243',
        dkName: '', imageUrl: CD
    },
    {
        code: 'CF',
        name: 'Central African Republic',
        phone: '236',
        dkName: '', imageUrl: CF
    },
    {
        code: 'CG',
        name: 'Congo, Republic of the',
        phone: '242',
        dkName: '', imageUrl: CG
    },
    { code: 'CH', name: 'Switzerland', phone: '41', dkName: 'SCHWEIZ', imageUrl: CH },
    { code: 'CI', name: "Cote d'Ivoire", phone: '225', dkName: '', imageUrl: CI },
    { code: 'CK', name: 'Cook Islands', phone: '682', dkName: '', imageUrl: CK },
    { code: 'CL', name: 'Chile', phone: '56', dkName: 'CHILE', imageUrl: CL },
    { code: 'CM', name: 'Cameroon', phone: '237', dkName: '', imageUrl: CM },
    { code: 'CN', name: 'China', phone: '86', dkName: 'KINA', imageUrl: CN },
    { code: 'CO', name: 'Colombia', phone: '57', dkName: 'COLOMBIA', imageUrl: CO },
    { code: 'CR', name: 'Costa Rica', phone: '506', dkName: '', imageUrl: CR },
    { code: 'CU', name: 'Cuba', phone: '53', dkName: '', imageUrl: CU },
    { code: 'CV', name: 'Cape Verde', phone: '238', dkName: '', imageUrl: CV },
    { code: 'CW', name: 'Curacao', phone: '599', dkName: '', imageUrl: CW },
    { code: 'CX', name: 'Christmas Island', phone: '61', dkName: '', imageUrl: CX },
    { code: 'CY', name: 'Cyprus', phone: '357', dkName: '', imageUrl: CY },
    { code: 'CZ', name: 'Czech Republic', phone: '420', dkName: 'TJEKKIET', imageUrl: CZ },
    {
        code: 'DE',
        name: 'Germany',
        phone: '49',
        suggested: true,
        dkName: 'TYSKLAND', imageUrl: DE
    },
    { code: 'DJ', name: 'Djibouti', phone: '253', dkName: '', imageUrl: DJ },
    { code: 'DK', name: 'Denmark', phone: '45', dkName: 'DANMARK', imageUrl: DK },
    { code: 'DM', name: 'Dominica', phone: '1-767', dkName: '', imageUrl: DM },
    {
        code: 'DO',
        name: 'Dominican Republic',
        phone: '1-809',
        dkName: '', imageUrl: DO
    },
    { code: 'DZ', name: 'Algeria', phone: '213', dkName: 'ALGERIET', imageUrl: DZ },
    { code: 'EC', name: 'Ecuador', phone: '593', dkName: '', imageUrl: EC },
    { code: 'EE', name: 'Estonia', phone: '372', dkName: 'ESTLAND', imageUrl: EE },
    { code: 'EG', name: 'Egypt', phone: '20', dkName: 'EGYPTEN', imageUrl: EG },
    { code: 'EH', name: 'Western Sahara', phone: '212', dkName: '', imageUrl: EH },
    { code: 'ER', name: 'Eritrea', phone: '291', dkName: '', imageUrl: ER },
    { code: 'ES', name: 'Spain', phone: '34', dkName: 'SPANIEN', imageUrl: ES },
    { code: 'ET', name: 'Ethiopia', phone: '251', dkName: '', imageUrl: ET },
    { code: 'FI', name: 'Finland', phone: '358', dkName: 'FINLAND', imageUrl: FI },
    { code: 'FJ', name: 'Fiji', phone: '679', dkName: '', imageUrl: FJ },
    {
        code: 'FK',
        name: 'Falkland Islands (Malvinas)',
        phone: '500',
        dkName: '', imageUrl: FK
    },
    {
        code: 'FM',
        name: 'Micronesia, Federated States of',
        phone: '691',
        dkName: '', imageUrl: FM
    },
    { code: 'FO', name: 'Faroe Islands', phone: '298', dkName: '', imageUrl: FO },
    {
        code: 'FR',
        name: 'France',
        phone: '33',
        suggested: true,
        dkName: 'FRANKRIG', imageUrl: FR
    },
    { code: 'GA', name: 'Gabon', phone: '241', dkName: '', imageUrl: GA },
    { code: 'GB', name: 'United Kingdom', phone: '44', dkName: 'ENGLAND', imageUrl: GB },
    { code: 'GD', name: 'Grenada', phone: '1-473', dkName: '', imageUrl: GD },
    { code: 'GE', name: 'Georgia', phone: '995', dkName: '', imageUrl: GE },
    { code: 'GF', name: 'French Guiana', phone: '594', dkName: '', imageUrl: GF },
    { code: 'GG', name: 'Guernsey', phone: '44', dkName: '', imageUrl: GG },
    { code: 'GH', name: 'Ghana', phone: '233', dkName: '', imageUrl: GH },
    // { code: 'GI', name: 'Gibraltar - UK', phone: '350', dkName: '' , imageUrl:GI},
    // { code: 'GL', name: 'Greenland', phone: '299', dkName: '' , imageUrl:GL},
    // { code: 'GM', name: 'Gambia', phone: '220', dkName: '' , imageUrl:GM},
    { code: 'GN', name: 'Guinea', phone: '224', dkName: '', imageUrl: GN },
    { code: 'GP', name: 'Guadeloupe', phone: '590', dkName: '', imageUrl: GP },
    { code: 'GQ', name: 'Equatorial Guinea', phone: '240', dkName: '', imageUrl: GQ },
    { code: 'GR', name: 'Greece', phone: '30', dkName: '', imageUrl: GR },
    {
        code: 'GS',
        name: 'South Georgia and the South Sandwich Islands',
        phone: '500',
        dkName: '', imageUrl: GS
    },
    { code: 'GT', name: 'Guatemala', phone: '502', dkName: '', imageUrl: GT },
    { code: 'GU', name: 'Guam', phone: '1-671', dkName: '', imageUrl: GU },
    { code: 'GW', name: 'Guinea-Bissau', phone: '245', dkName: '', imageUrl: GW },
    { code: 'GY', name: 'Guyana', phone: '592', dkName: '', imageUrl: GY },
    { code: 'HK', name: 'Hong Kong', phone: '852', dkName: 'HONG KONG', imageUrl: HK },
    {
        code: 'HM',
        name: 'Heard Island and McDonald Islands',
        phone: '672',
        dkName: '', imageUrl: HM
    },
    { code: 'HN', name: 'Honduras', phone: '504', dkName: '', imageUrl: HN },
    { code: 'HR', name: 'Croatia', phone: '385', dkName: '', imageUrl: HR },
    { code: 'HT', name: 'Haiti', phone: '509', dkName: '', imageUrl: HT },
    { code: 'HU', name: 'Hungary', phone: '36', dkName: 'UNGARN', imageUrl: HU },
    { code: 'ID', name: 'Indonesia', phone: '62', dkName: 'INDONISIEN', imageUrl: ID },
    { code: 'IE', name: 'Ireland', phone: '353', dkName: 'IRLAND', imageUrl: IE },
    { code: 'IL', name: 'Israel', phone: '972', dkName: '', imageUrl: IL },
    { code: 'IM', name: 'Isle of Man - UK', phone: '44', dkName: '', imageUrl: IM },
    { code: 'IN', name: 'India', phone: '91', dkName: 'INDIEN', imageUrl: IN },
    {
        code: 'IO',
        name: 'British Indian Ocean Territory',
        phone: '246',
        dkName: '', imageUrl: IO
    },
    { code: 'IQ', name: 'Iraq', phone: '964', dkName: '', imageUrl: IQ },
    {
        code: 'IR',
        name: 'Iran, Islamic Republic of',
        phone: '98',
        dkName: '', imageUrl: IR
    },
    { code: 'IS', name: 'Iceland', phone: '354', dkName: '', imageUrl: IS },
    { code: 'IT', name: 'Italy', phone: '39', dkName: 'ITALIEN', imageUrl: IT },
    // { code: 'JE', name: 'Channel Islands (Jersey/Guernsey) UK', phone: '44', dkName: '' , imageUrl:JE},
    { code: 'JM', name: 'Jamaica', phone: '1-876', dkName: '', imageUrl: JM },
    { code: 'JO', name: 'Jordan', phone: '962', dkName: 'JORDAN', imageUrl: JO },
    {
        code: 'JP',
        name: 'Japan',
        phone: '81',
        suggested: true,
        dkName: 'JAPAN'
        , imageUrl: JP
    },
    { code: 'KE', name: 'Kenya', phone: '254', dkName: 'KENYA', imageUrl: KE },
    { code: 'KG', name: 'Kyrgyzstan', phone: '996', dkName: '', imageUrl: KG },
    { code: 'KH', name: 'Cambodia', phone: '855', dkName: '', imageUrl: KH },
    { code: 'KI', name: 'Kiribati', phone: '686', dkName: '', imageUrl: KI },
    { code: 'KM', name: 'Comoros', phone: '269', dkName: '', imageUrl: KM },
    {
        code: 'KN',
        name: 'Saint Kitts and Nevis',
        phone: '1-869',
        dkName: '', imageUrl: KN
    },
    {
        code: 'KP',
        name: "Korea, Democratic People's Republic of",
        phone: '850',
        dkName: '', imageUrl: KP
    },
    { code: 'KR', name: 'Korea, Republic of', phone: '82', dkName: '', imageUrl: KR },
    { code: 'KW', name: 'Kuwait', phone: '965', dkName: '', imageUrl: KW },
    { code: 'KY', name: 'Cayman Islands', phone: '1-345', dkName: '', imageUrl: KY },
    { code: 'KZ', name: 'Kazakhstan', phone: '7', dkName: '', imageUrl: KZ },
    {
        code: 'LA',
        name: "Lao People's Democratic Republic",
        phone: '856',
        dkName: ''
        , imageUrl: LA
    },
    { code: 'LB', name: 'Lebanon', phone: '961', dkName: '', imageUrl: LB },
    { code: 'LC', name: 'Saint Lucia', phone: '1-758', dkName: '', imageUrl: LC },
    { code: 'LI', name: 'Liechtenstein', phone: '423', dkName: '', imageUrl: LI },
    { code: 'LK', name: 'Sri Lanka', phone: '94', dkName: '', imageUrl: LK },
    { code: 'LR', name: 'Liberia', phone: '231', dkName: '', imageUrl: LR },
    { code: 'LS', name: 'Lesotho', phone: '266', dkName: '', imageUrl: LS },
    { code: 'LT', name: 'Lithuania', phone: '370', dkName: 'LITAUEN', imageUrl: LT },
    { code: 'LU', name: 'Luxembourg', phone: '352', dkName: 'LUXEMBORG', imageUrl: LU },
    { code: 'LV', name: 'Latvia', phone: '371', dkName: 'LETLAND', imageUrl: LV },
    { code: 'LY', name: 'Libya', phone: '218', dkName: '', imageUrl: LY },
    { code: 'MA', name: 'Morocco', phone: '212', dkName: '', imageUrl: MA },
    { code: 'MC', name: 'Monaco', phone: '377', dkName: '', imageUrl: MC },
    {
        code: 'MD',
        name: 'Moldova, Republic of',
        phone: '373',
        dkName: ''
        , imageUrl: MD
    },
    { code: 'ME', name: 'Montenegro', phone: '382', dkName: '', imageUrl: ME },
    {
        code: 'MF',
        name: 'Saint Martin (French part)',
        phone: '590',
        dkName: '', imageUrl: MF
    },
    { code: 'MG', name: 'Madagascar', phone: '261', dkName: '', imageUrl: MG },
    { code: 'MH', name: 'Marshall Islands', phone: '692', dkName: '', imageUrl: MH },
    {
        code: 'MK',
        name: 'Macedonia, the Former Yugoslav Republic of',
        phone: '389',
        dkName: ''
        , imageUrl: MK
    },
    { code: 'ML', name: 'Mali', phone: '223', dkName: '', imageUrl: ML },
    { code: 'MM', name: 'Myanmar', phone: '95', dkName: '', imageUrl: MM },
    { code: 'MN', name: 'Mongolia', phone: '976', dkName: '', imageUrl: MN },
    { code: 'MO', name: 'Macao', phone: '853', dkName: '', imageUrl: MO },
    {
        code: 'MP',
        name: 'Northern Mariana Islands',
        phone: '1-670',
        dkName: ''
        , imageUrl: MP
    },
    { code: 'MQ', name: 'Martinique', phone: '596', dkName: '', imageUrl: MQ },
    { code: 'MR', name: 'Mauritania', phone: '222', dkName: '', imageUrl: MR },
    { code: 'MS', name: 'Montserrat', phone: '1-664', dkName: '', imageUrl: MS },
    { code: 'MT', name: 'Malta', phone: '356', dkName: '', imageUrl: MT },
    { code: 'MU', name: 'Mauritius', phone: '230', dkName: '', imageUrl: MU },
    { code: 'MV', name: 'Maldives', phone: '960', dkName: '', imageUrl: MV },
    { code: 'MW', name: 'Malawi', phone: '265', dkName: '', imageUrl: MW },
    { code: 'MX', name: 'Mexico', phone: '52', dkName: 'MEXICO', imageUrl: MX },
    { code: 'MY', name: 'Malaysia', phone: '60', dkName: 'MALAYSIA', imageUrl: MY },
    { code: 'MZ', name: 'Mozambique', phone: '258', dkName: '', imageUrl: MZ },
    { code: 'NA', name: 'Namibia', phone: '264', dkName: '', imageUrl: NA },
    { code: 'NC', name: 'New Caledonia', phone: '687', dkName: '', imageUrl: NC },
    { code: 'NE', name: 'Niger', phone: '227', dkName: '', imageUrl: NE },
    { code: 'NF', name: 'Norfolk Island', phone: '672', dkName: '', imageUrl: NF },
    { code: 'NG', name: 'Nigeria', phone: '234', dkName: '', imageUrl: NG },
    { code: 'NI', name: 'Nicaragua', phone: '505', dkName: '', imageUrl: NI },
    { code: 'NL', name: 'Netherlands', phone: '31', dkName: 'HOLLAND', imageUrl: NL },
    { code: 'NO', name: 'Norway', phone: '47', dkName: 'NORGE', imageUrl: NO },
    { code: 'NP', name: 'Nepal', phone: '977', dkName: '', imageUrl: NP },
    { code: 'NR', name: 'Nauru', phone: '674', dkName: '', imageUrl: NR },
    { code: 'NU', name: 'Niue', phone: '683', dkName: '', imageUrl: NU },
    { code: 'NZ', name: 'New Zealand', phone: '64', dkName: 'NEW ZEALAN', imageUrl: NZ },
    { code: 'OM', name: 'Oman', phone: '968', dkName: '', imageUrl: OM },
    { code: 'PA', name: 'Panama', phone: '507', dkName: '', imageUrl: PA },
    { code: 'PE', name: 'Peru', phone: '51', dkName: 'PERU', imageUrl: PE },
    { code: 'PF', name: 'French Polynesia', phone: '689', dkName: '', imageUrl: PF },
    { code: 'PG', name: 'Papua New Guinea', phone: '675', dkName: '', imageUrl: PG },
    { code: 'PH', name: 'Philippines', phone: '63', dkName: 'PHILIPINES', imageUrl: PH },
    { code: 'PK', name: 'Pakistan', phone: '92', dkName: '', imageUrl: PK },
    { code: 'PL', name: 'Poland', phone: '48', dkName: 'POLEN', imageUrl: PL },
    {
        code: 'PM',
        name: 'Saint Pierre and Miquelon',
        phone: '508',
        dkName: ''
        , imageUrl: PM
    },
    { code: 'PN', name: 'Pitcairn', phone: '870', dkName: '', imageUrl: PN },
    { code: 'PR', name: 'Puerto Rico', phone: '1', dkName: '', imageUrl: PR },
    {
        code: 'PS',
        name: 'Palestine, State of',
        phone: '970',
        dkName: ''
        , imageUrl: PS
    },
    { code: 'PT', name: 'Portugal', phone: '351', dkName: 'PORTUGAL', imageUrl: PT },
    { code: 'PW', name: 'Palau', phone: '680', dkName: '', imageUrl: PW },
    { code: 'PY', name: 'Paraguay', phone: '595', dkName: '', imageUrl: PY },
    { code: 'QA', name: 'Qatar', phone: '974', dkName: '', imageUrl: QA },
    { code: 'RE', name: 'Reunion', phone: '262', dkName: '', imageUrl: RE },
    { code: 'RO', name: 'Romania', phone: '40', dkName: 'RUMÆNIEN', imageUrl: RO },
    { code: 'RS', name: 'Serbia', phone: '381', dkName: 'SERBIEN', imageUrl: RS },
    { code: 'RU', name: 'Russian Federation', phone: '7', dkName: '', imageUrl: RU },
    { code: 'RW', name: 'Rwanda', phone: '250', dkName: '', imageUrl: RW },
    { code: 'SA', name: 'Saudi Arabia', phone: '966', dkName: 'SAUDI ARAB', imageUrl: SA },
    { code: 'SB', name: 'Solomon Islands', phone: '677', dkName: '', imageUrl: SB },
    { code: 'SC', name: 'Seychelles', phone: '248', dkName: '', imageUrl: SC },
    { code: 'SD', name: 'Sudan', phone: '249', dkName: '', imageUrl: SD },
    { code: 'SE', name: 'Sweden', phone: '46', dkName: 'SVERIGE', imageUrl: SE },
    { code: 'SG', name: 'Singapore', phone: '65', dkName: 'SINGAPORE', imageUrl: SG },
    { code: 'SH', name: 'Saint Helena', phone: '290', dkName: '', imageUrl: SH },
    { code: 'SI', name: 'Slovenia', phone: '386', dkName: 'SLOVENIEN', imageUrl: SI },
    {
        code: 'SJ',
        name: 'Svalbard and Jan Mayen',
        phone: '47',
        dkName: '', imageUrl: SJ
    },
    { code: 'SK', name: 'Slovakia', phone: '421', dkName: 'SLOVAKIET', imageUrl: SK },
    { code: 'SL', name: 'Sierra Leone', phone: '232', dkName: '', imageUrl: SL },
    { code: 'SM', name: 'San Marino', phone: '378', dkName: '', imageUrl: SM },
    { code: 'SN', name: 'Senegal', phone: '221', dkName: '', imageUrl: SN },
    { code: 'SO', name: 'Somalia', phone: '252', dkName: '', imageUrl: SO },
    { code: 'SR', name: 'Suriname', phone: '597', dkName: '', imageUrl: SR },
    { code: 'SS', name: 'South Sudan', phone: '211', dkName: '', imageUrl: SS },
    {
        code: 'ST',
        name: 'Sao Tome and Principe',
        phone: '239',
        dkName: ''
        , imageUrl: ST
    },
    { code: 'SV', name: 'El Salvador', phone: '503', dkName: '', imageUrl: SV },
    {
        code: 'SX',
        name: 'Sint Maarten (Dutch part)',
        phone: '1-721',
        dkName: ''
        , imageUrl: SX
    },
    {
        code: 'SY',
        name: 'Syrian Arab Republic',
        phone: '963',
        dkName: ''
        , imageUrl: SY
    },
    { code: 'SZ', name: 'Swaziland', phone: '268', dkName: '', imageUrl: SZ },
    {
        code: 'TC',
        name: 'Turks and Caicos Islands',
        phone: '1-649',
        dkName: ''
        , imageUrl: TC
    },
    { code: 'TD', name: 'Chad', phone: '235', dkName: '', imageUrl: TD },
    {
        code: 'TF',
        name: 'French Southern Territories',
        phone: '262',
        dkName: ''
        , imageUrl: TF
    },
    { code: 'TG', name: 'Togo', phone: '228', dkName: '', imageUrl: TG },
    { code: 'TH', name: 'Thailand', phone: '66', dkName: 'THAILAND', imageUrl: TH },
    { code: 'TJ', name: 'Tajikistan', phone: '992', dkName: '', imageUrl: TJ },
    { code: 'TK', name: 'Tokelau', phone: '690', dkName: '', imageUrl: TK },
    { code: 'TL', name: 'Timor-Leste', phone: '670', dkName: '', imageUrl: TL },
    { code: 'TM', name: 'Turkmenistan', phone: '993', dkName: '', imageUrl: TM },
    { code: 'TN', name: 'Tunisia', phone: '216', dkName: '', imageUrl: TN },
    { code: 'TO', name: 'Tonga', phone: '676', dkName: '', imageUrl: TO },
    { code: 'TR', name: 'Turkey', phone: '90', dkName: 'TYRKIET', imageUrl: TR },
    {
        code: 'TT',
        name: 'Trinidad and Tobago',
        phone: '1-868',
        dkName: ''
        , imageUrl: TT
    },
    // { code: 'TV', name: 'Tuvalu', phone: '688', dkName: '', imageUrl: TV },
    {
        code: 'TW',
        name: 'Taiwan',
        phone: '886',
        dkName: 'TAIWAN'
        , imageUrl: TW
    },
    {
        code: 'TZ',
        name: 'United Republic of Tanzania',
        phone: '255',
        dkName: ''
        , imageUrl: TZ
    },
    { code: 'UA', name: 'Ukraine', phone: '380', dkName: '', imageUrl: UA },
    { code: 'UG', name: 'Uganda', phone: '256', dkName: '', imageUrl: UG },
    {
        code: 'US',
        name: 'United States',
        phone: '1',
        suggested: true,
        dkName: 'USA'
        , imageUrl: US
    },
    { code: 'UY', name: 'Uruguay', phone: '598', dkName: '', imageUrl: UY },
    { code: 'UZ', name: 'Uzbekistan', phone: '998', dkName: '', imageUrl: UZ },
    {
        code: 'VA',
        name: 'Holy See (Vatican City State)',
        phone: '379',
        dkName: ''
        , imageUrl: VA
    },
    {
        code: 'VC',
        name: 'Saint Vincent and the Grenadines',
        phone: '1-784',
        dkName: ''
        , imageUrl: VC
    },
    { code: 'VE', name: 'Venezuela', phone: '58', dkName: '', imageUrl: VE },
    {
        code: 'VG',
        name: 'British Virgin Islands',
        phone: '1-284',
        dkName: ''
        , imageUrl: VG
    },
    {
        code: 'VI',
        name: 'US Virgin Islands',
        phone: '1-340',
        dkName: ''
        , imageUrl: VI
    },
    { code: 'VN', name: 'Vietnam', phone: '84', dkName: 'VIETNAM', imageUrl: VN },
    { code: 'VU', name: 'Vanuatu', phone: '678', dkName: '', imageUrl: VU },
    { code: 'WF', name: 'Wallis and Futuna', phone: '681', dkName: '', imageUrl: WF },
    { code: 'WS', name: 'Samoa', phone: '685', dkName: '', imageUrl: WS },
    { code: 'XK', name: 'Kosovo', phone: '383', dkName: '', imageUrl: XK },
    { code: 'YE', name: 'Yemen', phone: '967', dkName: '', imageUrl: YE },
    { code: 'YT', name: 'Mayotte', phone: '262', dkName: '', imageUrl: YT },
    { code: 'ZA', name: 'South Africa', phone: '27', dkName: 'SOUTH AFRI', imageUrl: ZA },
    { code: 'ZM', name: 'Zambia', phone: '260', dkName: '', imageUrl: ZM },
    { code: 'ZW', name: 'Zimbabwe', phone: '263', dkName: '', imageUrl: ZW },
];

export const getCountryCode = (code: string) => {
    if (code) {
        const country = newCountries.find(x => x.phone === code);
        if (country)
            return country;
    }
    return null;
}

export const euCountries = [
    "Andorra",
    "Albania",
    "Belgium",
    "Bosnia and Herzegovina",
    "Bulgaria",
    "Cyprus",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Gibraltar - UK",
    "Greece",
    "Netherlands",
    "Isle of Man - UK",
    "Ireland",
    "Italy",
    "Channel Islands (Jersey/Guernsey) UK",
    "Croatia",
    "Latvia",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Monaco",
    "Norway",
    "Poland",
    "Portugal",
    "Rumania",
    "San Marino",
    "Switzerland",
    "Slovakia",
    "Slovenia",
    "Spain",
    "United Kingdom",
    "Sweden",
    "Czech Republic",
    "Germany",
    "Hungary",
    "Austria"
];

export const isEuCountry = (country: string) => {
    return euCountries.some(x => x === country);
}

export const getCountry = (countryName: string) => {
    return newCountries.find(x => x.name === countryName);
}

export const getEnglishCountryName = (countryName: string) => {
    const engCountry = newCountries.find(x => x.dkName === countryName);
    if (engCountry) {
        return engCountry.name;
    }
    return countryName;
}
export const isTbd = (collectionDate: string) => {
    return collectionDate.includes("2030") || collectionDate.includes("1753") || collectionDate.includes("1930");
}

export const allCountryList: readonly string[] = [
    'Andorra',
    'United Arab Emirates',
    'Afghanistan',
    'Antigua and Barbuda',
    'Anguilla',
    'Albania',
    'Armenia',
    'Angola',
    'Antarctica',
    'Argentina',
    'American Samoa',
    'Austria',
    'Australia',
    'Aruba',
    'Alland Islands',
    'Azerbaijan',
    'Bosnia and Herzegovina',
    'Barbados',
    'Bangladesh',
    'Belgium',
    'Burkina Faso',
    'Bulgaria',
    'Bahrain',
    'Burundi',
    'Benin',
    'Saint Barthelemy',
    'Bermuda',
    'Brunei Darussalam',
    'Bolivia',
    'Brazil',
    'Bahamas',
    'Bhutan',
    'Bouvet Island',
    'Botswana',
    'Belarus',
    'Belize',
    'Canada',
    'Cocos (Keeling) Islands',
    'Congo, Democratic Republic of the',
    'Central African Republic',
    'Congo, Republic of the',
    'Switzerland',
    "Cote d'Ivoire",
    'Cook Islands',
    'Chile',
    'Cameroon',
    'China',
    'Colombia',
    'Costa Rica',
    'Cuba',
    'Cape Verde',
    'Curacao',
    'Christmas Island',
    'Cyprus',
    'Czech Republic',
    'Germany',
    'Djibouti',
    'Denmark',
    'Dominica',
    'Dominican Republic',
    'Algeria',
    'Ecuador',
    'Estonia',
    'Egypt',
    'Western Sahara',
    'Eritrea',
    'Spain',
    'Ethiopia',
    'Finland',
    'Fiji',
    'Falkland Islands (Malvinas)',
    'Micronesia, Federated States of',
    'Faroe Islands',
    'France',
    'Gabon',
    'United Kingdom',
    'Grenada',
    'Georgia',
    'French Guiana',
    'Guernsey',
    'Ghana',
    'Gibraltar - UK',
    'Greenland',
    'Gambia',
    'Guinea',
    'Guadeloupe',
    'Equatorial Guinea',
    'Greece',
    'South Georgia and the South Sandwich Islands',
    'Guatemala',
    'Guam',
    'Guinea-Bissau',
    'Guyana',
    'Hong Kong',
    'Heard Island and McDonald Islands',
    'Honduras',
    'Croatia',
    'Haiti',
    'Hungary',
    'Indonesia',
    'Ireland',
    'Israel',
    'Isle of Man - UK',
    'India',
    'British Indian Ocean Territory',
    'Iraq',
    'Iran, Islamic Republic of',
    'Iceland',
    'Italy',
    'Channel Islands (Jersey/Guernsey) UK',
    'Jamaica',
    'Jordan',
    'Japan',
    'Kenya',
    'Kyrgyzstan',
    'Cambodia',
    'Kiribati',
    'Comoros',
    'Saint Kitts and Nevis',
    "Korea, Democratic People's Republic of",
    'Korea, Republic of',
    'Kuwait',
    'Cayman Islands',
    'Kazakhstan',
    "Lao People's Democratic Republic",
    'Lebanon',
    'Saint Lucia',
    'Liechtenstein',
    'Sri Lanka',
    'Liberia',
    'Lesotho',
    'Lithuania',
    'Luxembourg',
    'Latvia',
    'Libya',
    'Morocco',
    'Monaco',
    'Moldova, Republic of',
    'Montenegro',
    'Saint Martin (French part)',
    'Madagascar',
    'Marshall Islands',
    'Macedonia, the Former Yugoslav Republic of',
    'Mali',
    'Myanmar',
    'Mongolia',
    'Macao',
    'Northern Mariana Islands',
    'Martinique',
    'Mauritania',
    'Montserrat',
    'Malta',
    'Mauritius',
    'Maldives',
    'Malawi',
    'Mexico',
    'Malaysia',
    'Mozambique',
    'Namibia',
    'New Caledonia',
    'Niger',
    'Norfolk Island',
    'Nigeria',
    'Nicaragua',
    'Netherlands',
    'Norway',
    'Nepal',
    'Nauru',
    'Niue',
    'New Zealand',
    'Oman',
    'Panama',
    'Peru',
    'French Polynesia',
    'Papua New Guinea',
    'Philippines',
    'Pakistan',
    'Poland',
    'Saint Pierre and Miquelon',
    'Pitcairn',
    'Puerto Rico',
    'Palestine, State of',
    'Portugal',
    'Palau',
    'Paraguay',
    'Qatar',
    'Reunion',
    'Romania',
    'Serbia',
    'Russian Federation',
    'Rwanda',
    'Saudi Arabia',
    'Solomon Islands',
    'Seychelles',
    'Sudan',
    'Sweden',
    'Singapore',
    'Saint Helena',
    'Slovenia',
    'Svalbard and Jan Mayen',
    'Slovakia',
    'Sierra Leone',
    'San Marino',
    'Senegal',
    'Somalia',
    'Suriname',
    'South Sudan',
    'Sao Tome and Principe',
    'El Salvador',
    'Sint Maarten (Dutch part)',
    'Syrian Arab Republic',
    'Swaziland',
    'Turks and Caicos Islands',
    'Chad',
    'French Southern Territories',
    'Togo',
    'Thailand',
    'Tajikistan',
    'Tokelau',
    'Timor-Leste',
    'Turkmenistan',
    'Tunisia',
    'Tonga',
    'Turkey',
    'Trinidad and Tobago',
    'Tuvalu',
    'Taiwan, Province of China',
    'United Republic of Tanzania',
    'Ukraine',
    'Uganda',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Holy See (Vatican City State)',
    'Saint Vincent and the Grenadines',
    'Venezuela',
    'British Virgin Islands',
    'US Virgin Islands',
    'Vietnam',
    'Vanuatu',
    'Wallis and Futuna',
    'Samoa',
    'Kosovo',
    'Yemen',
    'Mayotte',
    'South Africa',
    'Zambia',
    'Zimbabwe',
];

